import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import moment from 'moment';
import { RequestsService } from 'src/app/services/requests/requests.service';
import { AlertType, AlertBannerService } from 'src/app/lib/alert-banner';
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { WarningModalContentComponent } from 'src/app/lib/warning-modal/warning-modal.component';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';
import { RequestsPulseService } from 'src/app/services/requests/requests-pulse.service';
import * as Cookies from 'js-cookie';
import { PreviewQuestionnaireComponent } from '../../preview-questionnaire/preview-questionnaire.component';
import { Router } from '@angular/router';
import { PulseRequestsViewRecipientsComponent } from '../../pulse-requests-view-recipients/pulse-requests-view-recipients.component';
import { PlanService } from 'src/app/services/plan-status/plan-status.service';

@Component({
  selector: 'app-pulses',
  templateUrl: './pulses.component.pug',
  styleUrls: ['./pulses.component.scss'],
  standalone: false
})
export class PulsesComponent implements OnInit, OnChanges, OnDestroy {

  constructor(
    private modalService: BsModalService,
    private alertList: AlertBannerService,
    private requests: RequestsPulseService,
    private permissions: PermissionsService,
    private planservice: PlanService,
    private router: Router
  ) {}

  @Input() searchOption: any = undefined;
  @Input() rowsPerView = 20;
  @Input() currentPage = 1;
  @Input() sortString = '-created';
  @Input() filterOutput: any;
  @Input() backgroundRefreshCounter: number = 0;

  @Output() viewReport: EventEmitter<any> = new EventEmitter();
  @Output() outputLoading = new EventEmitter();
  @Output() outputTotal = new EventEmitter();
  @Output() outputNoData = new EventEmitter();
  @Output() outputSortOptions = new EventEmitter();
  @Output() outputFilterStatusOptions = new EventEmitter();

  // FEATURE FLAG START
  insightsPostV4FF:any
  sprint2315FeatureFlag = false;
  canViewPulseTab = true;
  // FEATURE FLAG END

  pulseTotalNumber = 0;
  pulseState = '';
  type = '';
  actionList: string[] = []
  cancelledBy = $localize`Cancelled by`
  cancelled = $localize`Cancelled`
  noPlanText = $localize`No active plan`
  noActivePlan = $localize`Sending cancelled due to no paid plan`;
  sendDateLabel = $localize`Send date`;
  userdetails = {};
  pulseNoAccessMessage = $localize`Access to the survey used in this request has been restricted by a user in your organisation.`


  sortOptions = [
    {
      'label': $localize`Request`,
      'type': "word",
      'value': "request"
    },
    {
      'label': $localize`Created by`,
      'type': "word",
      'value': "created_by"
    },
    {
      'label': $localize`Updated by`,
      'type': "word",
      'value': "updated_by"
    },
    {
      'label': $localize`Send date`,
      'type': "number",
      'value': "send_date"
    },
    {
      'label': $localize`Cutoff date`,
      'type': "number",
      'value': "cutoff_date"
    }
  ];

  filterStatusOptions = [
    { 'label': $localize`Scheduled`, 'value': 'Scheduled' },
    { 'label': $localize`Sending`, 'value': 'Sending' },
    { 'label': $localize`In progress`, 'value': 'pulseInprogress' },
    { 'label': $localize`Completed`, 'value': 'Completed' },
    { 'label': $localize`Stopped`, 'value': 'Stopped' },
    { 'label': $localize`Cancelled`, 'value': 'Cancelled' }
  ];

  requestsData: any;
  loading = true;
  total = 5;
  initialDataRequest = true;
  noData = false;
  deleteRequestWarningModal: BsModalRef = new BsModalRef();
  previewQuestionnaireComponent: BsModalRef = new BsModalRef();
  pulseRequestsRecepientsComponent: BsModalRef = new BsModalRef();
  isFeatureActive = false;
  pulse = ''
  totalPulseRecipientsDetails: any[] = [];
  totalRecipients: any;
  typeOfCheck = 'pulse';

  pagination = {
    "rowsPerView": 20,
    "currentPage": 1
  }
  sortCriteria = {
    "sortString": 'recipient',
    "sortOrder": 'asc'
  }

  pulseSortOptions = [
    {
      'label': "Recipient",
      'type': "word",
      'value': "recipient"
    },
    {
      'label': "Department",
      'type': "word",
      'value': "department"
    }
  ]
  searchTerm = '';
  filterBy = {
    'error': false,
    'warning': false
  };
  customDateStyling = '"font-family: \'TT Commons\';' +
    '    font-weight: normal; ' +
    '    font-size: 13px; ' +
    '    text-align: left; ' +
    '    color: #000; ' +
    '    opacity: 0.5;"';

  ngOnInit(): void {
    this.canViewPulseTab = (this.permissions.hasPermission('can_view_pulse_requests_list') || this.permissions.hasPermission('can_view_pulse_requests_list_with_survey_perms') || this.permissions.hasPermission('can_view_own_pulse_requests_list'));
      if (!this.canViewPulseTab) {
        this.loading = false;
      }


    window.scrollTo(0, 0);
    try {
      let doc = document.getElementById('container-xl')
      doc?.style.setProperty('max-width', '1152px')
    } catch {

    }
    if (this.canViewPulseTab) {
      this.initialiseData();
      this.emitToParent();
    }
  }

  ngOnDestroy() {
    let doc = document.getElementById('container-xl')
    doc?.style.setProperty('max-width', '1154px')
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Background refresh - silent refresh without loading indicator
    if (changes.backgroundRefreshCounter && !changes.backgroundRefreshCounter.firstChange) {
      this.initialiseData(true);
      return;
    }

    if (!this.initialDataRequest &&
      (changes.searchOption || changes.rowsPerView || changes.currentPage || changes.sortString || changes.filterOutput)) {
        this.initialiseData();
        this.emitToParent();
    }
  }

  initializePulsePermissions(request) {
    let user_uid = Cookies.get('user_uid')
    if(this.permissions.userRole == 'member') {
      if(request.user_uid != user_uid) {
        request.actionList = [$localize`View recipients`, $localize`View survey`]
      }
    } else if (this.permissions.userRole == 'member (restricted)') {
      if(request.user_uid != user_uid) {
        request.actionList = [$localize`No actions available`]
      }
    } else if (this.permissions.userRole == 'support') {
        request.actionList = [$localize`View recipients`, $localize`View survey`]
    }
  }

  initialiseData(silent: boolean = false) {
    this.initialDataRequest = this.areDefaultValues()
    if (!silent) {
      this.loading = true;
      this.emitToParent();
    }

    this.requests.getRequestsDuplicateParams(this.searchOption, this.rowsPerView, this.currentPage, this.sortString, this.filterOutput).subscribe(
      (res) => {
        this.requestsData = res.data.pulses;
        this.total = res.data.total;
        // if first/initial data request returns no data, means the page has no data at all, so show
        // noData image, don't show in any other circumstance eg. searches etc.
        if (this.total < 1 && this.initialDataRequest) {
          this.noData = true;
        } else {
          this.convertData();
          this.initialDataRequest = false;
        }

        this.requestsData.forEach(request => {
          request.actionButtonData = this.populateActionButton(request);
        });

        if (!silent) {
          this.loading = false;
        }
        this.emitToParent();
      }, error => {
        console.log(error);
        this.initialDataRequest = false;
        if (!silent) {
          if (error.status != 403) {
            this.alertList.append([{
              type: AlertType.DANGER,
              message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
              keepOnRouteChange: true
            }]);
          }
          this.loading = false;
        }
        this.emitToParent();
      });
  }

  emitToParent() {
    this.outputLoading.emit(this.loading);
    this.outputTotal.emit(this.total);
    this.outputNoData.emit(this.noData);
    this.outputSortOptions.emit(this.sortOptions);
    this.outputFilterStatusOptions.emit(this.filterStatusOptions);
  }

  convertData() {
    this.requestsData.forEach(request => {
      if (request.created) {
        let requested_date = moment(request.created);
        request.created = requested_date.format('ll');
        request.send_date = requested_date.format('ll');
      }
      if (request.modified) {
        let modified_date = moment(request.modified)
        request.modified = modified_date.format('ll')
      }
      if (request.expiry) {
        let expired_date = moment(request.expiry)
        request.expiry = expired_date.format('ll')
        request.internal_expiry = expired_date.format()
      }
      if (request.scheduled_time) {
        let scheduled_date = moment(request.scheduled_time)
        request.scheduled_time = scheduled_date.format('ll')
        request.send_date = scheduled_date.format('ll');
      }
      if (request.state == 0 && request.scheduled_time) {
        request.current_state = $localize`Scheduled`
        request.type = 'scheduled'
        request.current_count = request.total_recipients
        request.actionList = [$localize`Edit request`, $localize`View recipients`, $localize`View survey`, $localize`Cancel`]
      }
      else if (request.state == 1) {
        request.current_state = $localize`Stopped`
        request.type = 'stopped'
        request.current_count = `${request.total_completed+request.total_declined}/${request.total_recipients}`
        if(request.total_completed+request.total_declined==0) {
          request.actionList = [$localize`View recipients`, $localize`View survey`, $localize`Delete request`]
        } else {
          request.actionList = [$localize`View recipients`, $localize`View survey`]
        }
      }
      else if (request.state == 2 || (request.state == 0 && !request.scheduled_time)) {
        request.current_state = $localize`Sending`
        request.type = 'sending'
        request.current_count = request.total_recipients
        request.actionList = [$localize`View recipients`, $localize`View survey`]
      }
      else if (request.state == 3) {
        request.current_state = $localize`In progress`
        request.current_count =  `${request.total_completed+request.total_declined}/${request.total_recipients}`
        if(request.total_completed+request.total_declined == request.total_recipients){
          request.actionList = [$localize`View recipients`, $localize`View survey`]
        }else{
        request.actionList = [$localize`View recipients`, $localize`View survey`, $localize`Stop request`]
       }

      }
      else if (request.state == 5) {
        request.current_state = $localize`Completed`
        request.current_count = `${request.total_completed+request.total_declined}/${request.total_recipients}`
        request.actionList = [$localize`View recipients`, $localize`View survey`]
      }
      else if (request.state == 6 || request.state == 7) {
        request.type = 'cancelled'
        request.current_state = $localize`Cancelled`
        request.actionList = [$localize`Edit request`, $localize`View recipients`, $localize`View survey`, $localize`Delete request`]
      }
      this.initializePulsePermissions(request)
    });
  }

  deprecatedConvertData() {
    this.requestsData.forEach(request => {
      if (request.created) {
        let requested_date = moment(request.created);
        request.created = requested_date.format('ll');
        request.send_date = requested_date.format('ll');
      }
      if (request.modified) {
        let modified_date = moment(request.modified)
        request.modified = modified_date.format('ll')
      }
      if (request.expiry) {
        let expired_date = moment(request.expiry)
        request.expiry = expired_date.format('ll')
      }
      if (request.scheduled_time) {
        let scheduled_date = moment(request.scheduled_time)
        request.scheduled_time = scheduled_date.format('ll')
        request.send_date = scheduled_date.format('ll');
      }
      if (request.state == 0 && request.scheduled_time) {
        request.current_state = $localize`Scheduled`
        request.type = 'scheduled'
        request.current_count = request.total_recipients
        request.actionList = [$localize`Edit request`, $localize`View recipients`, $localize`View survey`, $localize`Cancel`]
      }
      else if (request.state == 1) {
        request.current_state = $localize`Stopped`
        request.type = 'stopped'
        request.current_count = `${request.total_completed+request.total_declined}/${request.total_recipients}`
        if(request.total_completed+request.total_declined==0) {
          request.actionList = [$localize`View recipients`, $localize`View survey`, $localize`Delete request`]
        } else {
          request.actionList = [$localize`View recipients`, $localize`View survey`]
        }
      }
      else if (request.state == 2 || (request.state == 0 && !request.scheduled_time)) {
        request.current_state = $localize`Sending`
        request.type = 'sending'
        request.current_count = request.total_recipients
        request.actionList = [$localize`View recipients`, $localize`View survey`]
      }
      else if (request.state == 3) {
        request.current_state = $localize`In progress`
        request.current_count =  `${request.total_completed+request.total_declined}/${request.total_recipients}`
        request.actionList = [$localize`View recipients`, $localize`View survey`, $localize`Stop request`]
      }
      else if (request.state == 5) {
        request.current_state = $localize`Completed`
        request.current_count = `${request.total_completed+request.total_declined}/${request.total_recipients}`
        request.actionList = [$localize`View recipients`, $localize`View survey`]
      }
      else if (request.state == 6 || request.state == 7) {
        request.type = 'cancelled'
        request.current_state = $localize`Cancelled`
        request.actionList = [$localize`Edit request`, $localize`View recipients`, $localize`View survey`, $localize`Delete request`]
      }
      this.initializePulsePermissions(request)
    });
  }

  setStatusColour(request) {
    let status = request.status.toLowerCase();
    if (status === 'submitted' || status === 'verified') {
      request.status_colour = 'green';
    }
    else if (status === 'in progress') {
      request.status_colour = 'yellow';
    }
    else if (status === 'declined' || status === 'deleted' || status === 'expired') {
      request.status_colour = 'red';
    }
    else if (status === 'invited') {
      request.status_colour = 'grey';
    }
  }

  omniCheckAction(request, action) {
    if(action===$localize`Delete request`) {
      this.deleteRequest(request)
    }
    else if (action===$localize`Cancel`) {
      this.cancelRequest(request)
    }
    else if(action===$localize`Stop request`) {
      this.stopRequest(request)
    }
    else if(action===$localize`Edit request`) {
      this.permissions.setNavCheck(false);
      this.routeToRequestPage(request)
    }
    else if(action===$localize`View survey`) {
      this.openPreview(request.questionnaire_id);
    }
    else if(action===$localize`View recipients`) {
      const initialState={
        'typeOfCheck': 'pulse',
        'check_uid': request.uid
      };
      this.pulseRequestsRecepientsComponent = this.modalService.show(
        PulseRequestsViewRecipientsComponent,
        { class: 'modal-dialog-centered l-popup', initialState},
      )
    }
  }

  routeToRequestPage(request:any) {
    this.router.navigateByUrl(`/request?check_uid=${request.uid}`, { state: { checkType: 'pulse', preFill: false } });
  }

  deleteRequest(request) {
    const initialState = {
      'title': $localize`Delete request`,
      'message': $localize`By deleting this request, it will be removed from your requests list.<br><br>Are you sure you want to delete this request?`,
      'typeModal': 'pulse-delete'
    }
    initialState['showWarningIcon'] = false
    initialState['addMargin'] = true


    this.deleteRequestWarningModal = this.modalService.show(WarningModalContentComponent,
      { class: 'modal-dialog-centered default-modal-pulse', initialState }
  );

    this.deleteRequestWarningModal.content.closeBtnName = 'Close';
    this.deleteRequestWarningModal.content.selection.subscribe(deleteBtnClicked => {
      if (deleteBtnClicked) {
        this.requests.deleteOmniRequest(request.uid).subscribe(
          (res) => {
            this.requests.clearCache(); // Clear cache on successful action
            this.requestsData = this.requestsData?.filter(pulse_request => { return pulse_request.uid !== request.uid })
            this.alertList.append([{
              type: AlertType.SUCCESS,
              message: $localize`Success! The request has been deleted.`,
              keepOnRouteChange: true
            }])
          }, error => {
            console.log(error);
            this.alertList.append([{
              type: AlertType.DANGER,
              message: $localize`This request has been started by the recipient and can no longer be deleted.`,
              keepOnRouteChange: true
            }]);
          })
      }
    });
  }
  cancelRequest(request) {

    const initialState = {
      'title': $localize`Cancel request?`,
      'message': $localize`By cancelling this request, it will not be sent to the recipients. It will still appear in your requests list and can be edited.<br><br>Are you sure you want to cancel the request?`,
      'typeModal': 'pulse-cancel',
      'PulseButtonText': "Yes, I'm sure"
    }

    initialState['title'] = $localize`Cancel request`,
    initialState['PulseButtonText'] = $localize`Yes, I'm sure`,
    initialState['cancelButton'] = $localize`No`
    initialState['showWarningIcon'] = false
    initialState['addMargin'] = true


    this.deleteRequestWarningModal = this.modalService.show(WarningModalContentComponent,
      { class: 'modal-dialog-centered default-modal-pulse', initialState }
    );

    this.deleteRequestWarningModal.content.closeBtnName = 'Close';
    this.deleteRequestWarningModal.content.selection.subscribe(deleteBtnClicked => {
      if (deleteBtnClicked) {
        this.requests.cancelOmniRequest(request.uid).subscribe(
          (res) => {
            this.requests.clearCache(); // Clear cache on successful action
            request.state = 7
            request.current_state = $localize`Cancelled`
            request.updated_by = res.updated_by
            request.type = undefined
            request.actionList = [$localize`Edit request`, $localize`View recipients`, $localize`View survey`, $localize`Delete request`]

            this.initialiseData()

            this.alertList.append([{
              type: AlertType.SUCCESS,
              message: $localize`Success! The request has been cancelled.`,
              keepOnRouteChange: true
            }])
          }, error => {
            console.log(error);
            this.alertList.append([{
              type: AlertType.DANGER,
              message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
              keepOnRouteChange: true
            }]);
          })
      }
    });
  }
  stopRequest(request) {
    const initialState = {
      'title': $localize`Stop request`,
      'message': $localize`By stopping this request, no further responses will be collected. Insights for this request will be available if five or more responses have already been collected.<br><br>Are you sure you want to stop this request?`,
      'typeModal': 'pulse-cancel',
      'PulseButtonText': "Stop request"
    }

    initialState['showWarningIcon'] = false
    initialState['addMargin'] = true


    this.deleteRequestWarningModal = this.modalService.show(WarningModalContentComponent,
      { class: 'modal-dialog-centered default-modal-pulse', initialState }
    );

    this.deleteRequestWarningModal.content.closeBtnName = 'Close';
    this.deleteRequestWarningModal.content.selection.subscribe(deleteBtnClicked => {
      if (deleteBtnClicked) {
        this.requests.stopOmniRequest(request.uid).subscribe(
          (res) => {
            this.requests.clearCache(); // Clear cache on successful action
            request.state = 1
            request.current_state = $localize`Stopped`
            request.updated_by = res.updated_by
            request.type = undefined
            if(request.total_completed+request.total_declined==0) {
              request.actionList = [$localize`View recipients`, $localize`View survey`, $localize`Delete request`]
            } else {
              request.actionList = [$localize`View recipients`, $localize`View survey`]
            }
            this.initialiseData()
            this.alertList.append([{
              type: AlertType.SUCCESS,
              message: $localize`Success! The request has been stopped.`,
              keepOnRouteChange: true
            }])
          }, error => {
            console.log(error);
            this.alertList.append([{
              type: AlertType.DANGER,
              message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
              keepOnRouteChange: true
            }]);
          })
      }
    });
  }
  createHTML(request) {
    if (request.state == 7) {
      let mainString = ''
      const string = `<div class="pill-state"><p class="pill-text">${this.cancelledBy} ${request.updated_by}</p></div>
                      <p class="internal-date">${request.modified}</p>`
      mainString +=string
      return mainString
    } else if (request.state == 6) {
      let mainString = ''
      const string = `<div class="pill-state"><p class="pill-text">${this.cancelled}</p></div>
                      <p class="internal-date">${this.noPlanText}</p>`
      mainString +=string
      return mainString
    }
    else {
      let dummyArray = [{"type": $localize`Submitted`, "count":request.total_completed}, {"type": $localize`Declined`, "count": request.total_declined}]
      let mainString = ''
      for(let i=0;i<dummyArray.length;i++) {
        if (dummyArray[i]['type'] == 'Declined') {
          const string = `<div class="pill-state"><p class="pill-text">Declined</p><div class="inner-pill-circle"><p class="inner-pill-number">${dummyArray[i]['count']}</p></div></div>`
          mainString +=string
        }
        else if ((dummyArray[i]['type'] == 'Submitted')) {
          const string = `<div class="pill-state"><p class="pill-text">Submitted</p><div class="inner-pill-circle-green"><p class="inner-pill-number-green">${dummyArray[i]['count']}</p></div></div>`
          mainString +=string
        }
      }
      return mainString
    }
  }
  statusSelectAssign(request, inputClass) {
    // As cleanup is hard in pug file, keeping function selection logic here
    return this.statusSelectAssignV1(request, inputClass);
  }

  statusSelectAssignV1(request, inputClass) {
    let isExpired = moment.utc(request.internal_expiry) < moment.utc(moment());
    if(request.state==0 || request.state==2 || (request.state==3 && !isExpired && request.total_completed < request.total_sent)) {
      if(inputClass === 'status-select') {
        return 'status-select-wheat'
      }
      else if (inputClass == 'status-font') {
        return 'status-font-wheat';
      }
      else if(inputClass == 'internal-pill') {
        return 'internal-pill-wheat'
      }
    }
    else if((request.state==5 && (request.total_completed==request.total_sent || (isExpired && request.total_completed>=5 ))) || (request.state==1 && request.total_completed>=5)) {
      if(inputClass === 'status-select') {
        return 'status-select-green'
      }
      else if (inputClass == 'status-font') {
        return 'status-font-green';
      }
      else if(inputClass == 'internal-pill') {
        return 'internal-pill-green'
      }
    }
    else if((request.state==3 && request.total_completed>5) || (request.state==5 && (request.total_completed<5) && isExpired) || (request.state==1 && (request.total_completed<5 || request.total_completed==0))) {
      if(inputClass === 'status-select') {
        return 'status-select-black'
      }
      else if (inputClass == 'status-font') {
        return 'status-font-black';
      }
      else if(inputClass == 'internal-pill') {
        return 'internal-pill-black'
      }
    }
    else if(request.state==7 || request.state==6) {
      if(inputClass === 'status-select') {
        return 'status-select-black'
      }
      else if (inputClass == 'status-font') {
        return 'status-font-black';
      }
      else if(inputClass == 'internal-pill') {
        return 'internal-pill-black'
      }
    }
  return 'true'
  }

  deprecatedStatusSelectAssign(request, inputClass) {
    let isExpired = moment.utc(request.expiry) < moment.utc(new Date())
    if(request.state==0 || request.state==2 || (request.state==3 && (request.total_completed)<5)) {
      if(inputClass === 'status-select') {
        return 'status-select-wheat'
      }
      else if (inputClass == 'status-font') {
        return 'status-font-wheat';
      }
      else if(inputClass == 'internal-pill') {
        return 'internal-pill-wheat'
      }
    }
    else if((request.state==3 && (request.total_completed)>=5) || (request.state==5 && (request.total_completed==request.total_sent || (request.total_completed>=5))) || (request.state==1 && request.total_completed>=5)) {
      if(inputClass === 'status-select') {
        return 'status-select-green'
      }
      else if (inputClass == 'status-font') {
        return 'status-font-green';
      }
      else if(inputClass == 'internal-pill') {
        return 'internal-pill-green'
      }
    }
    else if((request.state==3 && request.total_completed>5) || (request.state==5 && (request.total_completed<5)) || (request.state==1 && (request.total_completed<5 || request.total_completed==0))) {
      if(inputClass === 'status-select') {
        return 'status-select-black'
      }
      else if (inputClass == 'status-font') {
        return 'status-font-black';
      }
      else if(inputClass == 'internal-pill') {
        return 'internal-pill-black'
      }
    }
    else if(request.state==7 || request.state==6) {
      if(inputClass === 'status-select') {
        return 'status-select-black'
      }
      else if (inputClass == 'status-font') {
        return 'status-font-black';
      }
      else if(inputClass == 'internal-pill') {
        return 'internal-pill-black'
      }
    }
  return 'true'
  }

  onViewReport(request) {
    // Add log when clicked on pulse request
    if (this.checkSurveyPermissionOnRequest(request)) {
      if (request.total_completed < 5) {
        return;
      }
      this.userdetails = this.permissions.hasxrpUserPermission();
      const metaData = {
        "log": {
          "user_id": this.userdetails['user_id'],
          "email": this.userdetails['email'],
          "name": this.userdetails['name'],
          "username": this.userdetails['username'],
          "message": "User clicked on pulse request " + request.uid
        },
        "audit_log": "CLICK_PULSE_REQUEST"
      };
      this.planservice.postLog(metaData);
      let state = {
        state: {
          'request': request,
          'pulseStart': request.send_date,
          'pulseEnd': request.send_date
        }
      }
      this.router.navigateByUrl('/insights', state);
    }
  }

  openPreview(questionnaire_id) {
    const initialState={
      'questionnaireId': questionnaire_id,
      'createSurvey': true,
      'surveyType': 'pulse',
      'pageType': 'requests'
    };
    this.previewQuestionnaireComponent = this.modalService.show(
      PreviewQuestionnaireComponent,
      { class: 'modal-dialog-centered xl-popup', initialState},
    )
  }

  checkSurveyPermissionOnRequest(request) {
    return request.questionnaire_permissions
  }
  onClickRequestPulseCard(event: any, request) {
    this.onViewReport(request)
  }
  handlePermissions(event: any, request) {
    if(!this.checkSurveyPermissionOnRequest(request))
    {
      event.stopPropagation();
      event.preventDefault();
      console.log('Has No Permission');
    }
  }
  handleKebabAction(event, request) {
    this.omniCheckAction(request, event.value);
  }
  titleCase(str) {
    return str.toLowerCase().split(' ').map(function(word) {
      return (word.charAt(0).toUpperCase() + word.slice(1));
    }).join(' ');
  }
  getStatusInformation(request)
  {
    let pulseCutoffIncomplete = false;
    if((request.state==3 && request.total_completed>5) ||
      (request.state==5 && (request.total_completed<5) && moment.utc(request.internal_expiry) < moment.utc(moment())) ||
      (request.state==1 && (request.total_completed<5 || request.total_completed==0))) {
      pulseCutoffIncomplete = true;
    }
    if(request.state==7 || request.state==6) {
      pulseCutoffIncomplete = true;
    }

    let current_count = 0;
    if (request.state == 0 && request.scheduled_time) {
      if (request.total_recipients > 0)
      {
        return {
          hasTag: true,
          nestedStatTagText: request.total_recipients,
          tagText: request.current_state,
          status: this.translateStateToOriginal(request),
          tagCompleted: request.total_recipients,
          tagTotal: 0,
          pulseCutoffIncomplete: pulseCutoffIncomplete,
          cancelledBy: ''
        }
      }
      else {
        return {
          hasTag: true,
          nestedStatTagText: request.total_recipients,
          tagText: request.current_state,
          status: this.translateStateToOriginal(request),
          tagCompleted: 1,
          tagTotal: request.total_recipients,
          pulseCutoffIncomplete: pulseCutoffIncomplete,
          cancelledBy: ''
        }
      }
    }
    else if (request.state == 1) {
      current_count = request.total_completed+request.total_declined;
    }
    else if (request.state == 2 || (request.state == 0 && !request.scheduled_time)) {
      current_count = request.total_recipients;
    }
    else if (request.state == 3) {
      current_count =  request.total_completed+request.total_declined;
    }
    else if (request.state == 5) {
      current_count = request.total_completed+request.total_declined;
      if (request.state==5 && (request.total_completed<5) && moment.utc(request.internal_expiry) < moment.utc(moment()))
      {
        pulseCutoffIncomplete = true;
        return {
          hasTag: true,
          nestedStatTagText: '',
          tagText: request.current_state,
          status: this.translateStateToOriginal(request),
          tagCompleted: current_count,
          tagTotal: request.total_recipients,
          pulseCutoffIncomplete: true,
          cancelledBy: ''
        }
      }
    }
    return {
      hasTag: true,
      nestedStatTagText: '',
      tagText: request.current_state,
      status: this.translateStateToOriginal(request),
      tagCompleted: current_count,
      tagTotal: request.total_recipients,
      pulseCutoffIncomplete: pulseCutoffIncomplete,
      cancelledBy: ''
    }
  }
  getTopInformationFromRequest(request)
  {
    return [
      {label: $localize`Created by`, content: request.created_by},
      {label: $localize`Last updated ${'('+request.modified+')'}`, content: request.updated_by},
      {label: $localize`Cutoff date`, content: request?.expiry}
    ]
  }

  getCreatedByInfo(request) {
    return {label: $localize`Created by`, content: request.created_by}
  }

  getLastUpdatedInfo(request) {
    return {label: $localize`Last updated ${'('+request.modified+')'}`, content: request.updated_by}
  }

  getCutoffDateInfo(request) {
    return {label: $localize`Cutoff date`, content: request?.expiry}
  }

  populateActionButton(request) {
    if (!request?.actionList || request.actionList.length === 0)
    {
      return [{key: '0', value: $localize`No actions available`}];
    }

    let actions = [];
    for(let i=0; i<request.actionList.length; i++){
      // @ts-ignore
      actions.push({key: i, value: request.actionList[i], disabled: request.is_restricted});
    }
    return actions;
  }
  translateStateToOriginal(request) {
    if (request.state == 0 && request.scheduled_time) {
      return 'Scheduled';
    }
    else if (request.state == 1) {
      return 'Stopped';
    }
    else if (request.state == 2 || (request.state == 0 && !request.scheduled_time)) {
      return 'Sending';
    }
    else if (request.state == 3) {
      return 'In progress';
    }
    else if (request.state == 5) {
      return 'Completed';
    }
    else if (request.state == 6 || request.state == 7) {
      return 'Cancelled';
    }
    return '';
  }
  createTooltip(request){
    if ([1, 3, 5].includes(request.state)) {
      return [
        {label: 'Submitted', content: request.total_completed, colour: 'forest'},
        {label: 'Declined', content: request.total_declined},
      ];
    }
    else if (request.state == 6) {
      return [
        {
          label: `${this.noActivePlan}`,
          content: ''
        }
      ]
    }
    else if (request.state == 7) {
      return [
        {
        label: this.cancelledBy,
          content: '<div style="font-size: 16px;">'+request.updated_by+'<div style="font-size: 16px;">\n' +
            `<div style=${(this.customDateStyling)}>${request.modified}</div>`
        }
      ]
    }
    return [
      {label: '', content: ''}
    ];
  }

  areDefaultValues() {
    const isSearchOptionDefault = this.searchOption?.length === 0
    const isrowsPerViewDefault = this.rowsPerView === 20
    const iscurrentPageDefault = this.currentPage === 1
    const isSortStringDefault = this.sortString === '-send_date'
    const isfilterOutputDefault = this.filterOutput === null
    return isSearchOptionDefault && isrowsPerViewDefault && iscurrentPageDefault && isSortStringDefault && isSortStringDefault && isfilterOutputDefault
  }
}
